import { clsx, type ClassValue } from "clsx";

import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function makeSelectOptions(strList: string[]) {
  return strList.map((str) => ({ label: str, value: str }));
}

export function getApiUrl() {
  const defaultUrl = "http://localhost:8000";
  const map: Record<string, string> = {
    "localhost": "http://localhost:8000",
    "localhost:5173": "http://localhost:8000",
    "stg.app.koyouassess.biz": "https://stg.api.koyouassess.biz",
    "stg.app-no-sdg.koyouassess.biz": "https://stg.api-no-sdg.koyouassess.biz",
    "app.koyouassess.biz": "https://api.koyouassess.biz",
    "koyouassess.jp": "https://api.koyouassess.jp",
    "consult.koyouassess.biz": "https://api.consult.koyouassess.biz",
    "consult.workvisa.jp": "https://api.consult.workvisa.jp",
  };

  if (typeof window === "undefined") {
    return defaultUrl;
  }

  const host = window.location.hostname;
  const fullHost = window.location.host;
  return map[host] ?? map[fullHost] ?? defaultUrl;
}

export const calculateTotalGrade = (totalScore: number, score: number | null) => {
  if (score === null) return "N/A";
  if (score >= totalScore * 0.9) return "S";
  if (score >= totalScore * 0.8) return "A";
  if (score >= totalScore * 0.6) return "B";
  if (score >= totalScore * 0.4) return "C";
  return "D";
};

export const getGradeRangesByTotalScore = (totalScore: number) => {
  if (totalScore <= 0) return ["-", "-", "-", "-", "-"];

  const sMin = Math.ceil(totalScore * 0.9);
  const aMin = Math.ceil(totalScore * 0.8);
  const bMin = Math.ceil(totalScore * 0.6);
  const cMin = Math.ceil(totalScore * 0.4);

  return [
    `${sMin}点以上`,
    `${aMin}-${sMin - 1}点`,
    `${bMin}-${aMin - 1}点`,
    `${cMin}-${bMin - 1}点`,
    `${cMin}点未満`,
  ];
};

export const calculateGrade = (score: number | null) => {
  if (score === null) return "N/A";
  if (score >= 90) return "S";
  if (score >= 80) return "A";
  if (score >= 60) return "B";
  if (score >= 40) return "C";
  return "D";
};

export const getColorByScore = (score: number | null) => {
  if (score === null) return "text-cool-gray-500";
  if (score >= 90) return "text-amber-600";
  if (score >= 80) return "text-green-600";
  if (score >= 60) return "text-blue-gray-600";
  if (score >= 50) return "text-cool-gray-700";
  return "text-red-600";
};
